// URL search-param schema for /cms/itineraries.

export type CmsItinerariesSearch = {
  search?: string;
  visibility?: 'visible' | 'hidden';
  hashtagIds?: string[];
  page?: number;
};

const asStringArray = (v: unknown): string[] | undefined =>
  Array.isArray(v)
    ? v.filter((x): x is string => typeof x === 'string')
    : undefined;

export const validateCmsItinerariesSearch = (
  input: Record<string, unknown>
): CmsItinerariesSearch => {
  const result: CmsItinerariesSearch = {};
  if (typeof input.search === 'string' && input.search.length > 0) {
    result.search = input.search;
  }
  if (input.visibility === 'visible' || input.visibility === 'hidden') {
    result.visibility = input.visibility;
  }
  const hashtagIds = asStringArray(input.hashtagIds);
  if (hashtagIds && hashtagIds.length > 0) {
    result.hashtagIds = hashtagIds;
  }
  if (typeof input.page === 'number' && input.page > 0) {
    result.page = input.page;
  } else if (typeof input.page === 'string') {
    const n = Number.parseInt(input.page, 10);
    if (Number.isFinite(n) && n > 0) result.page = n;
  }
  return result;
};
